export default __webpack_public_path__ + "static/media/segre27.7c73d5b2.jpg";